export function ErrorIcon() {
  return (
    <svg
      className="consult-entry__status-icon"
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      aria-hidden="true">
      <circle cx="21" cy="21" r="20" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M15 15L27 27"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M27 15L15 27"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
